import { render, staticRenderFns } from "./DispatchEdit.vue?vue&type=template&id=3f136c90&"
import script from "./DispatchEdit.vue?vue&type=script&lang=js&"
export * from "./DispatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports